import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown, DropdownButton, Dropdown, Row, Col } from 'react-bootstrap'
import { useSelector } from "react-redux";
import { logout, userStore } from "../../../redux/reduxStore.js";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { IconMenu3, IconCaretDownFilled, IconUserCircle } from '@tabler/icons-react';

const UserHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname || "home");

  const handleHashChange = () => {
    setActiveLink(location.pathname);
  }

  useEffect(() => {
    handleHashChange();
  }, [location]);

  const user = useSelector((state) => state.user);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="fixed-btn">
        <a href="https://wa.me/16476920900" target="_blank" className="whatsapp"><img src="../Images/whatsapp.png" alt="" /></a>
      </div>
      {!user?.kyc && activeLink !== "/kyc" ?
        <div className="head-top">
          <Container>
            <Row>
              <Col md={12}>
                <div className='kyc-info'>
                  <span>Your account is pending for KYC(<Link to={'/kyc'} target='_blank'>Click to complete KYC</Link>)</span>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        : null}
      <Navbar expand="xl" id="header" className='user-header' ref={menuRef} expanded={isMenuOpen}>
        <Container fluid>
          <Link to="/home" className="navbar-brand"><img src="../Images/myfx-logo-new.png" alt="" /></Link>
          <div className="d-xl-none d-flex align-items-center gap-3">
            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle}>
              <IconMenu3 size={40} stroke={2} />
            </Navbar.Toggle>
            <Link className={`${activeLink == "Userprofile" || activeLink == "/Userprofile" ? 'active' : ''}`} to="/Userprofile">
              <IconUserCircle size={30} stroke={1} color="#FFA300" />
            </Link>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto me-xl-5">
              <Link className={`nav-link ${activeLink === "/home" || activeLink === "Home" ? 'active' : ''}`} to="/home">Home</Link>
              <NavDropdown title={
                <Link to="/services" className={`dd-link ${activeLink === "/services" || activeLink === "/realestateinvestmentpayments" || activeLink === "/tuitionpaymentsforcanada" || activeLink === "/applyforletterofcredit" || activeLink === "/effortlessglobalpayments" || activeLink === "services" ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>Our services</Link>} id="basic-nav-dropdown">
                <Link to="/effortlessglobalpayments" className={`dropdown-item ${activeLink === "effortlessglobalpayments" || activeLink === "/effortlessglobalpayments" ? 'active' : ''}`}>Effortless Global Payments</Link>
                <Link to="/applyforletterofcredit" className={`dropdown-item ${activeLink === "/applyforletterofcredit" || activeLink === "applyforletterofcredit" ? 'active' : ''}`}>Apply for Letter of Credit (LC)</Link>
                <Link to="/tuitionpaymentsforcanada" className={`dropdown-item ${activeLink === "/tuitionpaymentsforcanada" || activeLink === "tuitionpaymentsforcanada" ? 'active' : ''}`}>Tuition Payments for Canada</Link>
                <Link to="/realestateinvestmentpayments" className={`dropdown-item ${activeLink === "/realestateinvestmentpayments" || activeLink === "realestateinvestmentpayments" ? 'active' : ''}`}>Real Estate Investment Payments</Link>
              </NavDropdown>
              <Link className={`nav-link ${activeLink === "about" || activeLink === "/about" ? 'active' : ''}`} to="/about">About us</Link>
              <Link className={`nav-link ${activeLink === "contact" || activeLink === "/contact" ? 'active' : ''}`} to="/contact">Contact</Link>
              <Link className={`nav-link ${activeLink === "dashboard" || activeLink === "/dashboard" ? 'active' : ''}`} to="/dashboard">Dashboard</Link>
              <Link className={`nav-link ${activeLink === "/" || activeLink == "userrequestquote" || activeLink === "/userrequestquote" ? 'active' : ''}`} to="/userrequestquote">Quotations</Link>
              <Link className={`nav-link ${activeLink === "userorders" || activeLink === "/userorders" ? 'active' : ''}`} to="/userorders">Orders</Link>
              <Link className={`nav-link ${activeLink === "trackorder" || activeLink === "/trackorder" ? 'active' : ''}`} to="/trackorder">Track order</Link>
              <Link className={`nav-link d-flex d-xl-none ${activeLink === "changepassword" || activeLink === "/changepassword" ? 'active' : ''}`} to="/changepassword">Change password</Link>
              <Link onClick={() => { userStore.dispatch(logout()); }} to={'/home'} className="nav-link d-flex d-xl-none">Logout</Link>
            </Nav>
            <div className="user-bar">
              <DropdownButton autoClose id="dropdown-basic-button" align="end"
                title={
                  <div className='userinfo'>
                    <div className="left">
                      <IconUserCircle size={30} stroke={1} />
                      <span>{user?.userName}</span>
                    </div>
                    <div className="right">
                      <IconCaretDownFilled size={18} stroke={2} />
                    </div>
                  </div>
                }>
                <Link to="/userprofile" className={`dropdown-item ${activeLink === "Userprofile" || activeLink === "/userprofile" ? 'active' : ''}`}>My Profile</Link>
                <Link to="/changepassword" className={`dropdown-item ${activeLink === "Changepassword" || activeLink === "/changepassword" ? 'active' : ''}`}>Change password</Link>
                <Dropdown.Divider />
                <button onClick={() => { userStore.dispatch(logout()); navigate('/') }} className="dropdown-item">Logout</button>
              </DropdownButton>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}

export default UserHeader